// extracted by mini-css-extract-plugin
module.exports = {"modalbody":"CustomModal_modalbody__Z7O9m","close-btn":"CustomModal_close-btn__qF044"};